import {Injectable} from '@angular/core';
import {BaseModelService} from '../base-model.service';

@Injectable({
  providedIn: 'root'
})
export class FiltersModelService extends BaseModelService {

  tableName = 'yu_v3_filters';

  public async listKey(key: string): Promise<any> {
    return this.list().then((data) => {
      this.data = new Object(data);

      return this.data[key];
    });
  }

  public async saveKey(dataToSave: any, key: string): Promise<any> {
    if (!this.data) {
      this.data = new Object({});
    }

    this.data[key] = dataToSave;

    return this.save(this.data).then(() => this.data[key]);
  }

}
